import React, { ReactNode, CSSProperties } from 'react';
import RemindRoundIcon from '@rsuite/icons/RemindRound';
import InfoRoundIcon from '@rsuite/icons/InfoRound';
import CheckRoundIcon from '@rsuite/icons/CheckRound';
import RemindFillIcon from '@rsuite/icons/RemindFill';
import { Message, MessageProps, Stack, Text } from 'rsuite';

export interface NoticeProps extends MessageProps {
  message?: string | ReactNode;
  type?: 'error' | 'info' | 'warning' | 'success';
  showIcon?: boolean;
  iconSize?: number;
  iconBottomOffset?: number;
  messageStyle?: CSSProperties;
  isMessageComponent?: boolean;
  spacing?: number;
  actionComponent?: ReactNode;
}

const Notice: React.FC<NoticeProps> = ({
  message,
  type = 'error',
  showIcon = true,
  iconSize = 24,
  iconBottomOffset = 2,
  messageStyle = undefined,
  isMessageComponent = false,
  spacing = 15,
  actionComponent = null,
  ...rest
}) => {
  const role = type === 'error' ? 'alert' : 'status';
  return (
    <Message
      type={type}
      role={role}
      {...rest}
    >
      <Stack
        direction="row"
        spacing={spacing}
        alignItems="center"
      >
        {showIcon ? (
          <>
            {type === 'error' && (
              <RemindRoundIcon
                aria-hidden="true"
                style={{
                  fontSize: iconSize,
                  marginBottom: iconBottomOffset,
                }}
              />
            )}
            {type === 'info' && (
              <InfoRoundIcon
                aria-hidden="true"
                style={{
                  fontSize: iconSize,
                  marginBottom: iconBottomOffset,
                }}
              />
            )}
            {type === 'warning' && (
              <RemindFillIcon
                aria-hidden="true"
                style={{
                  fontSize: iconSize,
                  marginBottom: iconBottomOffset,
                }}
              />
            )}
            {type === 'success' && (
              <CheckRoundIcon
                aria-hidden="true"
                style={{
                  fontSize: iconSize,
                  marginBottom: iconBottomOffset,
                }}
              />
            )}
          </>
        ) : null}

        {!isMessageComponent && <Text style={messageStyle}>{message}</Text>}
        {isMessageComponent && message}
        {actionComponent}
      </Stack>
    </Message>
  );
};

export default Notice;
